import {
  Delete,
  KeyboardArrowDown,
  KeyboardArrowUp,
  MoreVert,
  OpenInNew,
} from '@mui/icons-material';
import {
  Box,
  Collapse,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  ToggleButton,
  Typography,
} from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useState } from 'react';

const GetObservacionText = (value = '', maxLength = 50) => {
  if (value == null) return '';
  const text = String(value).trim();
  return text.length <= maxLength ? text : text.slice(0, maxLength) + '…';
};

export const DatosDesplegableRow = (props) => {
  const { denuncia, onHandlePreview: onPreview, onAnular } = props;
  const [open, setOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const openAction = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAnular = (autorizacion) => {
    if (onAnular) onAnular(autorizacion);
    handleClose();
  };

  const onHandlePreview = (autorizacion) => {
    if (onPreview) onPreview(autorizacion);
    handleClose();
  };

  return (
    <Box sx={{ width: '100%' }}>
      <ToggleButton
        aria-label='expand row'
        value='check'
        onChange={() => {
          setOpen(!open);
        }}
        sx={{ border: 0, p: 0 }}
        fullWidth={true}
      >
        <Grid
          container
          direction='row'
          justifyContent='flex-start'
          alignItems='center'
          gap={2}
          flexWrap='nowrap'
        >
          {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          <List sx={{ p: 0 }}>
            <ListItem sx={{ py: 0 }}>
              <ListItemText
                sx={{ py: 0 }}
                primaryTypographyProps={{ textTransform: 'none', fontSize: '14px' }}
                primary={` ${denuncia?.afiliadonumerodocumento || ''}`}
              />
            </ListItem>
            <ListItem sx={{ py: 0 }}>
              <ListItemText
                primaryTypographyProps={{ fontSize: '14px' }}
                primary={`nº: ${denuncia?.idFormateado || ''}`}
              />
            </ListItem>
          </List>
          <List sx={{ p: 0 }}>
            <ListItem sx={{ justifyContent: 'flex-end', p: 0 }}>
              <ListItemButton
                aria-label='more'
                id='long-button'
                aria-controls={openAction ? 'long-menu' : undefined}
                aria-expanded={openAction ? 'true' : undefined}
                aria-haspopup='true'
                onClick={handleClick}
              >
                <MoreVert />
              </ListItemButton>
              <Menu
                id='long-menu'
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={openAction}
                onClose={handleClose}
                slotProps={{
                  style: {
                    maxHeight: 58 * 4.5,
                    width: '200px',
                  },
                }}
              >
                <MenuItem key={'ver-solicitud'} onClick={() => onHandlePreview(denuncia)}>
                  <GridActionsCellItem
                    icon={<OpenInNew />}
                    title='Ver Solicitud'
                    label='Ver Solicitud'
                  />
                  <Typography variant='body2'>Ver Solicitud</Typography>
                </MenuItem>
                <MenuItem
                  key={'anular'}
                  onClick={() => {
                    handleAnular(denuncia);
                  }}
                  disabled={denuncia.codigoEstado !== '1'}
                >
                  <GridActionsCellItem
                    icon={<Delete />}
                    title='Anular Solicitud'
                    label='Anular Solicitud'
                  />
                  <Typography variant='body2'>Anular Solicitud</Typography>
                </MenuItem>
              </Menu>
            </ListItem>
          </List>
        </Grid>
      </ToggleButton>

      <Collapse in={open} timeout='auto' unmountOnExit>
        <Box>
          <List sx={{ py: 0 }}>
            <ListItem sx={{ py: 0 }} style={{ fontWeight: 'bold' }}>
              <ListItemText
                primaryTypographyProps={{ fontSize: '14px' }}
                primary={
                  denuncia?.tipoCobertura && (
                    <>
                      <b>Tipo </b> {denuncia?.tipoCobertura}
                    </>
                  )
                }
              />
            </ListItem>
            <ListItem sx={{ py: 0 }} style={{ fontWeight: 'bold' }}>
              <ListItemText
                primaryTypographyProps={{ fontSize: '14px' }}
                primary={
                  denuncia?.estado && (
                    <>
                      <b>Estado </b> {denuncia?.estado}
                    </>
                  )
                }
                sx={{ my: 0 }}
              />
            </ListItem>
            <ListItem sx={{ py: 0 }} style={{ fontWeight: 'bold' }}>
              <ListItemText
                primaryTypographyProps={{ fontSize: '14px' }}
                primary={
                  denuncia?.observacion && (
                    <>
                      <b>Observación </b> {GetObservacionText(denuncia?.observacion)}
                    </>
                  )
                }
                sx={{ my: 0 }}
              />
            </ListItem>
          </List>
        </Box>
      </Collapse>
    </Box>
  );
};
